export const SearchIcon = () => {
    return (
        <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-black dark:stroke-darkSurface-600">
            <path
                d="M6.333 11.667A5.333 5.333 0 1 0 6.333 1a5.333 5.333 0 0 0 0 10.667ZM13 13l-2.9-2.9"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
